import React, { useState, useEffect, useRef } from 'react'
import CustomDatatableInstitutionCategory from '../../components/CustomDatatableInstitutionCategory/CustomDatatableInstitutionCategory';
import './InstitutionCategoryList.css';
import { BiPlusMedical } from 'react-icons/bi';
import { GoCloudDownload } from 'react-icons/go';
import { AiOutlineFileExcel } from 'react-icons/ai';
import AddOrEditInstitutionCategory from '../../components/AddOrEditInstitutionCategory/AddOrEditInstitutionCategory';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import DeleteConfirmation from '../../components/DeleteConfirmation/DeleteConfirmation';
import { useNavigate } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection, searchFunction, reload, usePrevious } from '../../utils/utils';
import { getInstitutionCategories } from '../../services/http';
import swal from 'sweetalert';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import { FaTablets } from 'react-icons/fa';
import Loader from '../../components/Loader/Loader';


const InstitutionCategory = () => {


  const tableColumns = [
    { id: "1", label: "#" },
    { id: "2", label: "Libellé" }
  ]

  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const states = useSelector((state) => state, shallowEqual);
  const [displayLoader, setDisplayLoader] = useState(true);


  // To populate the breadcrumb and update the sidebar menu
  useEffect(async () => {
    dispatch({
      type: "SET",
      key: "breadcrumbContent",
      payload: {
        firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Catégorie d'institution", secondLevelLink: "/institution-category", thirdLevelText: "", thirdLevelLink: ""
      }
    });
    handleMenuSelection("settings", dispatch, states);
    handleSubMenuSelection("institutions-categories", dispatch)
  }, [])

  const fetchInstitutionCategories = async (page, search) => {
    let institution_categories_list_response = await getInstitutionCategories(states.userToken.access_token, page, search);
    let institution_categories_list_response_copy = institution_categories_list_response?.data.data?.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
    const perPageValue = institution_categories_list_response?.data?.per_page
    setPerPage(perPageValue)
    console.log(institution_categories_list_response_copy)
    const total = institution_categories_list_response?.data?.total;
    setTotalPage(Math.ceil(total / perPageValue))
    dispatch({
      type: "SET",
      key: "institutionCategoriesList",
      payload: institution_categories_list_response_copy,
    });
    setDisplayLoader(false);
  }

  useEffect(() => {
    fetchInstitutionCategories(pageNumber, search)
    console.log(pageNumber)
    console.log(search)
  }, [pageNumber, search])

  const goToImportScreen = () => {
    navigate("/import-institution-category")
  }




  const handleCloseDeleteModal = (id) => {
    let index = states.institutionCategoriesList.findIndex(x => x.id === id);
    console.log("index is : ", index)
    let newTableData = [...states.institutionCategoriesList];
    newTableData[index].showDelete = false;

    dispatch({
      type: "SET",
      key: "institutionCategoriesList",
      payload: newTableData,
    });
  };
  const handleShowDeleteModal = (id) => {
    let index = states.institutionCategoriesList.findIndex(x => x.id === id);
    console.log("index is : ", index)
    let newTableData = [...states.institutionCategoriesList];
    newTableData[index].showDelete = true;
    dispatch({
      type: "SET",
      key: "institutionCategoriesList",
      payload: newTableData,
    });
  };

  const handleSearchChange = (e) => {
    console.log(e.currentTarget.value)
    setSearch(e.currentTarget.value)

  }

  const changePage = ({ selected }) => {

    let currentPage = selected + 1;
    setPageNumber(currentPage)
  }



  return (
    <div>
      <Navbar />
      <div className="main-container" id="container">
        <Sidebar />

        <div id="content" className="main-content">
          <div className="layout-px-spacing mb-4">

            <div className="row layout-top-spacing">
              <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
              </div>
            </div>
            {/* <AddOrEditInstitutionCategory operationType={"new"} show={states.showNewInstitutionCategory} handleClose={handleCloseNewCatModal} /> */}
            <h2 className="mb-3 text-left">Liste des catégories d'institution</h2>
            {displayLoader == false ?
            <div className="widget widget-content widget-content-area">
              <div className="dataTables_wrapper  dt-bootsrap4">
                <div className="dt--top-section container-fluid mt-4 pt-3 px-3">
                  <div className="row">
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-start justify-content-center mb-3">
                      <form class="form-inline justify-content-center search-input-container mb-3">
                        <div class="w-100 d-flex flex-nowrap search-input-container">
                          <input type="text" onChange={handleSearchChange} class=" form-control product-search br-30" id="input-search" placeholder="Rechercher..." />

                        </div>
                      </form>
                    </div>
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-end justify-content-center mb-3 mt-sm-0 mt-3">
                      {states.userPermissions?.create_category_institution !== undefined && <div>
                        <button className="btn btn-info mb-2" onClick={() => navigate("/institution-category/new")}> <BiPlusMedical className="" /> Ajouter</button>
                        <button className="btn btn-dark ml-3 mb-2" onClick={goToImportScreen}><AiOutlineFileExcel className="mr-1" />Importer</button>
                      </div>}
                    </div>
                  </div>
                </div>

                {states.institutionCategoriesList && states.institutionCategoriesList?.length != 0 ?
                  <CustomDatatableInstitutionCategory
                    onExit={reload}
                    columns={tableColumns}
                    data={states.institutionCategoriesList}
                    handleCloseDeleteModal={handleCloseDeleteModal}
                    handleShowDeleteModal={handleShowDeleteModal}
                    changePage={changePage}
                    pageCount={totalPage}
                    pageNumber={pageNumber}
                    perPage={perPage}
                  /> : <h4 className="py-3">Aucun résultat</h4>}
              </div>
            </div> : <div style={{ marginTop: "25%" }}>
                  <Loader />
                </div>}

          </div>

        </div>
      </div>
    </div>)
}

export default InstitutionCategory